import type React from 'react';

interface DotLoaderProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

export const DotLoader: React.FC<DotLoaderProps> = ({ color = 'bg-blue-500', size = 'medium' }) => {
  const dotSize = {
    large: 'w-3 h-3',
    medium: 'w-2 h-2',
    small: 'w-1 h-1',
  };

  const containerSize = {
    large: 'gap-3',
    medium: 'gap-2',
    small: 'gap-1',
  };

  return (
    <div aria-hidden="true" className={`flex items-center justify-center ${containerSize[size]}`}>
      {[0, 1, 2].map((index) => (
        <span
          className={`${dotSize[size]} ${color} dot-loader-dot rounded-full`}
          key={index}
          style={{ animationDelay: `${index * 0.18}s` }}
        />
      ))}
    </div>
  );
};
